import { handleDateRangeCalendarChange } from "../shared/utils/form-date.js";
function formHandlers_handleDateRangeCalendarChange(setValue, setDefaultMonth, dates) {
    handleDateRangeCalendarChange(setValue, 'hotelStartDate', 'hotelEndDate', setDefaultMonth, dates, {
        clearEndDateOnStart: true
    });
}
export { formHandlers_handleDateRangeCalendarChange as handleDateRangeCalendarChange };
